import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { AgentAbsence } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function deleteAgentAbsence(absence: AgentAbsence) {
  return api.delete(`/support/absences/${absence.id}`).then(axiosSuccess).catch(axiosError);
}

export function useDeleteAgentAbsence() {
  const queryClient = useQueryClient();

  return useMutation((absence: AgentAbsence) => deleteAgentAbsence(absence), {
    onSuccess: () => {
      handleRequestSuccess('Ausência removida com sucesso!');
      queryClient.invalidateQueries('agent-absences');
      queryClient.invalidateQueries('support-agents');
      queryClient.invalidateQueries('support-stats');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao remover ausência. Tente novamente.');
    },
  });
}
